import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button } from '@numbox/components';
import { AuthModule } from '@numbox/modules';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';
import { LoginContext } from './LoginContext';
import { ROUTES } from './constants';

export const ChooseAuth = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { email } = useContext(LoginContext);

  return (
    <Prompt data-cy="choose-auth" variant="auth">
      <PromptHeader
        logoType="icon"
        title="Welcome back!"
        subtitle={<span>We need to make sure it&apos;s really you.</span>}
      />
      <PromptContent>
        <Button
          onClick={() => {
            dispatch(
              AuthModule.requestMagicLink.request(
                { email, token_type: 'MAGIC_LINK' },
                undefined,
              ),
            );

            history.push(`.${ROUTES.CHECK_EMAIL}`);
          }}
        >
          Send a sign-in link to my email
        </Button>
        <Button
          isPrimary
          data-cy="know-password-btn"
          onClick={() => history.push(`.${ROUTES.ENTER_PASSWORD}`)}
        >
          I know my password
        </Button>
      </PromptContent>
    </Prompt>
  );
};
